import { useState } from 'react';
import styled from 'styled-components';

import { Frame, TExtra } from './StyledTemplates';

import { isna } from 'utils/common-helper';

import imgIconsArrowDown from 'assets/icons/arrow-down.svg';

type CommunityTabProps = {
    title?: any;
    description?: any;
    closable?: boolean;
    headerColor?: any;
    rightEndComponent?: any;
    extraBody?: any;
    extraHeader?: any;
    extra?: any;
    children?: any;
    rightEndComponentStyles?: any;
    isOpened?: boolean;
    isOpenedDefault?: boolean;
    className?: string;
    centerComponent?: any;
};

const CommunityTab = (props: CommunityTabProps) => {
    const {
        title,
        description,
        closable = false,
        headerColor,
        rightEndComponent,
        extraBody,
        rightEndComponentStyles,
        extra,
        isOpened: isOpenedProps,
        isOpenedDefault,
        className = '',
        extraHeader = '',
        centerComponent,
    } = props;
    const [opened, setOpened] = useState(!closable || isOpenedProps || isOpenedDefault);
    const handleClose = () => {
        if (closable) {
            setOpened(!opened);
        }
    };
    const isOpened = typeof isOpenedProps === 'boolean' ? isOpenedProps : opened;
    return (
        <TabWrapper extra={extra ?? ''} className={className}>
            <TabHeader
                narrow={isna(title) && isna(description)}
                headerColor={headerColor}
                visible={isOpened}
                onClick={handleClose}
                extra={extraHeader ?? ''}
            >
                <div className="d-flex ml-2 pr-4 align-items-start max-w-lg">
                    <Title className="serif">{title}</Title>
                    {description && <DescriptionWrapper>{description}</DescriptionWrapper>}
                </div>
                {/* <Frame extra="align-items: flex-start; margin-right: 10px; padding-right: 10px; @media (max-width: 991px) { align-items: flex-start; }">
                    <Title className="serif">{title}</Title>
                    {description && <DescriptionWrapper>{description}</DescriptionWrapper>}
                </Frame> */}
                {centerComponent || null}
                <Frame extra={rightEndComponentStyles ?? ``}>
                    {closable && (!isna(title) || !isna(description)) && isna(rightEndComponent) ? (
                        <ArrowDown $opened={isOpened} />
                    ) : null}
                    {rightEndComponent ?? null}
                </Frame>
            </TabHeader>
            <TabBody visible={isOpened} extra={extraBody}>
                {props.children}
            </TabBody>
        </TabWrapper>
    );
};

const DescriptionWrapper = styled(Frame)`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
`;

const Title = styled(Frame)`
    font-size: 20px;
    line-height: 30px;
    padding-right: 20px;

    display: block;
    /* max-width: calc(800px - 130px); */
    max-width: calc(800px - 326px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    @media (max-width: 991px) {
        white-space: normal;
        max-width: 80vw;
    }
`;

const ArrowDown = styled(Frame)<{ $opened?: boolean }>`
    cursor: pointer;
    width: 35px;
    height: 35px;
    background: url('${imgIconsArrowDown}') no-repeat center center / contain;
    transform: rotate(${({ $opened }) => ($opened ? 0 : 180)}deg);

    @media (max-width: 991px) {
        position: absolute;
        top: 10px;
        right: 10px;
    }
`;

const TabWrapper = styled(Frame)<{ extra?: string }>`
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    /* width: 100%; */

    @media (max-width: 991px) {
        /* max-width: 92vw; */
        /* overflow: visible; */
    }

    ${({ extra }) => extra}
`;

const TabHeader = styled(Frame)<{ narrow?: boolean; headerColor?: any; visible?: boolean; extra?: TExtra }>`
    width: 100%;
    padding: ${({ narrow }) => (narrow ? '0.25em ' : '')} 1.25em;
    background: ${({ theme, headerColor }) => headerColor ?? theme.primary_action};
    flex-direction: row;
    justify-content: space-between;
    border-radius: 10px 10px ${({ visible }) => (visible ? 0 : 10)}px ${({ visible }) => (visible ? 0 : 10)}px;
    * {
        color: white;
    }

    position: relative;

    @media (max-width: 991px) {
        flex-direction: column;
        gap: 5px;
        align-items: flex-start;
        padding: 15px 7px 15px 30px;
    }

    ${({ extra }) => extra}
`;

const TabBody = styled(Frame)<{ visible?: boolean; extra?: TExtra }>`
    width: 100%;
    padding: ${({ visible = false }) => (visible ? 1.5 : 0)}em;
    box-sizing: border-box;
    background: ${({ theme }) => theme.background.primary};
    height: ${({ visible = false }) => (visible ? 'auto' : '0px')};
    /* overflow: hidden; */
    visibility: ${({ visible = false }) => (visible ? 'visible' : 'hidden')};
    opacity: ${({ visible = false }) => (visible ? 1 : 0)};
    border-radius: 0px 0px 10px 10px;

    > * {
        ${({ visible = false }) => !visible && 'display: none;'}
    }

    @media (max-width: 991px) {
        padding: ${({ visible = false }) => (visible ? '1.5em 0.75em' : 0)};
    }

    ${({ extra }) => extra}
`;

export default CommunityTab;
